
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29","height":"27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M26 0a2.38 2.38 0 012.38 2.38V24A2.38 2.38 0 0126 26.38H2.38A2.38 2.38 0 010 24V2.38A2.38 2.38 0 012.38 0H26zm1.67 5.659H.75V24c0 .9.73 1.63 1.63 1.63H26A1.63 1.63 0 0027.67 24V5.659zM9.32 8.09a.5.5 0 01.5.5v14.06a.5.5 0 01-.5.5H4.33a.5.5 0 01-.5-.5V8.59a.5.5 0 01.5-.5h4.99zm7.26 0a.5.5 0 01.5.5v14.06a.5.5 0 01-.5.5h-4.99a.5.5 0 01-.5-.5V8.59a.5.5 0 01.5-.5h4.99zm7.26 0a.5.5 0 01.5.5v14.06a.5.5 0 01-.5.5h-4.99a.5.5 0 01-.5-.5V8.59a.5.5 0 01.5-.5h4.99zM26 .75H2.38c-.9 0-1.63.73-1.63 1.63v2.529h26.92V2.38A1.63 1.63 0 0026 .75zM3.58 2.3a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L3.58 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L6.46 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L9.34 2.3z"}})])
          )
        }
      }
    